<!-- Trigger input -->
<mat-form-field class="date-input-field" [ngClass]="{ 'input-error': isError }">
  <input
    #dateInput
    matInput
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="openDatepicker($event)"
    [value]="displayLabel"
    [placeholder]="isPlaceholderShown ? ('MAIN.CHOOSE_DATE' | translate) : ''"
    autocomplete="off"
    readonly
    [disabled]="isDisabled"
  />
</mat-form-field>

<!--
  Custom popup overlay.
  - NO hasBackdrop: the backdrop is transparent but still blocks mouse events → buttons are not clickable.
    Use the document:click HostListener in TS to detect outside clicks instead.
  - cdkConnectedOverlayPositions: positions the popup below the input, falls back to above if there is not enough space.
-->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div class="datepicker-custom-popup" #popupContainer>
    <!--
      Inline daterangepicker uses direct Input bindings (NOT ngModel):
      - ngx-daterangepicker-material standalone component does not implement ControlValueAccessor
        → [ngModel] throws "dir.valueAccessor.writeValue is not a function"
      - Use [startDate]/[endDate]: when recallTimeRange() assigns a new `selected` + markForCheck(),
        Angular re-evaluates bindings → calls the startDate/endDate setters on the library
        → library.updateView() → time selects reflect the new value ✓
      - (datesUpdated) captures all changes (date click, range shortcut, time select).
      - Library's default .buttons are hidden via SCSS → using the custom footer below.
    -->
    <ngx-daterangepicker-material
      [startDate]="pickerInitDate.startDate"
      [endDate]="pickerInitDate.endDate"
      [timePicker]="isWithTimePicker"
      [timePicker24Hour]="true"
      [linkedCalendars]="true"
      [alwaysShowCalendars]="true"
      [keepCalendarOpeningWithRange]="isRange"
      [locale]="locale"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [ranges]="ranges"
      [singleDatePicker]="!isRange"
      [showClearButton]="false"
      [showCustomRangeLabel]="isRange"
      [autoApply]="false"
      (datesUpdated)="onDatesUpdated($event)"
    ></ngx-daterangepicker-material>

    <!-- Custom footer – replaces the library's built-in .buttons row -->
    <div class="popup-footer">
      <!-- Save / Recall time (only meaningful when time picker is active) -->
      @if (isWithTimePicker) {
      <div class="footer-time-actions">
        <button
          mat-raised-button
          type="button"
          color="accent"
          (click)="saveTimeRange()"
          [matTooltip]="'REPORTS.TIME_RANGE_CONFIG.SAVE_TOOLTIP' | translate"
        >
          {{ 'REPORTS.TIME_RANGE_CONFIG.SAVE_BUTTON' | translate }}
        </button>

        <button
          mat-raised-button
          type="button"
          color="accent"
          (click)="recallTimeRange()"
          [disabled]="!savedTimeRangeLabel"
          [matTooltip]="
            savedTimeRangeLabel
              ? ('REPORTS.TIME_RANGE_CONFIG.APPLY_TOOLTIP' | translate: { time: savedTimeRangeLabel }) +
                '\n' +
                ('REPORTS.TIME_RANGE_CONFIG.CACHE_WARNING' | translate)
              : ('REPORTS.TIME_RANGE_CONFIG.NO_SAVED_TOOLTIP' | translate)
          "
          matTooltipClass="multiline-tooltip"
        >
          {{ 'REPORTS.TIME_RANGE_CONFIG.RECALL_BUTTON' | translate }}
        </button>

        @if (showEachDayCheckbox && isWithTimePicker) {
        <mat-checkbox
          [(ngModel)]="isTimeRangeForEachDay"
          (ngModelChange)="onEachDayToggle()"
          [matTooltip]="'REPORTS.TIME_RANGE_CONFIG.EACH_DAY_TOOLTIP' | translate"
        >
          {{ 'REPORTS.TIME_RANGE_CONFIG.EACH_DAY_LABEL' | translate }}
        </mat-checkbox>
        }
      </div>
      }

      <!-- Apply / Cancel -->
      <div class="footer-apply-actions">
        <button mat-button type="button" (click)="cancel()">{{ 'BUTTONS.CANCEL' | translate }}</button>
        <button mat-raised-button type="button" color="accent" (click)="apply()">{{ 'MAIN.DONE' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>
